import { useInfiniteQuery } from 'react-query';
import { marketingProjectService } from 'services';
import { ServerStateKeysEnum } from '../../constants';

export const useFetchMarketingProjects = (filters: {
  status?: string;
  includeThumbnail?: boolean;
  perPageSize?: number;
  currentPageNumber?: number;
}) => {
  const cacheKey = buildCacheKey(filters.status);
  return useInfiniteQuery(
    cacheKey,
    ({ pageParam = 1 }) => {
      return marketingProjectService.getMarketingProjects({
        ...filters,
        currentPageNumber: pageParam,
      });
    },
    {
      getNextPageParam: (lastPage, pages) => {
        if (
          'currentPageNumber' in lastPage &&
          typeof lastPage.currentPageNumber === 'number'
        ) {
          if (lastPage.currentPageNumber === lastPage.totalPages) {
            return undefined;
          } else {
            return lastPage.currentPageNumber + 1;
          }
        }
        return undefined;
      },
      staleTime: Infinity,
      enabled: true,
    }
  );
};

export const buildCacheKey = (status?: string, projectId?: string) => {
  let cacheKey = [];
  cacheKey.push(ServerStateKeysEnum.marketingProjects);
  if (status) {
    cacheKey.push(status);
  } else {
    cacheKey.push('all');
  }
  return cacheKey;
};
